export default "__VITE_ASSET__1aa9418a__"